// `/c/{slug}/notifications` (SEARCH-NOTIF): account menu › Notifications — the caller's own
// notification preferences in this company (features/notifications/notification-settings.tsx).
import { createRoute } from "@tanstack/react-router";
import { NotificationSettings } from "../features/notifications/notification-settings";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { companyRoute } from "./c.$slug";

export const notificationsRoute = createRoute({
  getParentRoute: () => companyRoute,
  path: "notifications",
  validateSearch: (search: Record<string, unknown>) => validateFocusSearch(search),
  component: function Notifications() {
    const { api } = notificationsRoute.useRouteContext();
    return <NotificationSettings api={api} company={useCompany()} />;
  },
});
